import React, { useEffect, useContext, useState } from "react";
import { useLocation, useHistory, Link } from "react-router-dom";
import GlobalSearch from "../GlobalSearch/GlobalSearch";
import {
  mtoUserNavList,
  NavList,
  SellerCentralNavSubList,
} from "./NavigationUrlList";
import AppContext from "../../../context/appcontext";
import {
  ROLE_MTO_MEMBER,
  // ROLE_MTO_ADMIN,
  // EXTERNAL_VENDOR_GENERIC,
  LIVE,
  VENDORPLATFORM_SUB_HEAD_LOCATIONDETAILS,
} from "../../../constants/Constants";
import Cookie from "js-cookie";
import * as RolePermissionConstants from "../../../constants/RolePermissionConstants";
import {
  getUserRolePermission,
  verifyAccessPermission,
} from "../../../utils/rolePermissionAccess";

import { Navbar, Nav, Dropdown } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";

import "../../../assets/css/Common.css";
import "./MainNavigation.css";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { updateServiceData } from "../../../redux/serviceSlice";
//import { updateCommonInfo } from "../../../redux/commonSlice";
import { updateLeftNav } from "../../../redux/leftNavSlice";
import { checkOnBoardingStatus } from "../../../utils/utils";
import * as Constants from "../../../constants/Constants";
import { getDisableEnableConfig } from "../../VendorOnboarding/OnboardingHelper";
import { httpGetVendorProfileByEmail } from "../../../service/httpClient";

const currentyear = new Date().getFullYear();

// const yearoptions = [
//   currentyear,
//   currentyear - 1,
//   currentyear - 2,
//   currentyear - 3,
// ];

const getYear = () => {
  const pathname = window.location.pathname;
  if (pathname.includes("/dashboard")) {
    const year = pathname.split("/dashboard/").pop();
    return /^([0-9]{4})$/.test(year) && year;
  }
  return "";
};

const MainNavigation = (props) => {
  const context = useContext(AppContext);

  const location = useLocation();
  const history = useHistory();
  const dispatch = useDispatch();
  const [state, setState] = useState({
    home: location.pathname.indexOf("mvp") > -1 ? true : false,
    publishNotification:
      location.pathname.indexOf("publish") > -1 ? true : false,
    updateProfile: location.pathname.indexOf("vendor") > -1 ? true : false,
    dashboard: location.pathname.indexOf("dashboard") > -1 ? true : false,
    selectedOption: getYear(),
    searchVisible: false,
    filterVisble: false,
    dashboardVisible: false,
    navList: NavList,
    sellerCentralNavSubList: SellerCentralNavSubList,
  });

  const store = useSelector(
    ({ service, common }) => ({
      onboardingStatus: common.boardingStatuses?.onboardingStatus,
      isPrimaryVendor: service?.vendorProfile?.vendorDetail?.isPrimaryVendor,
      liveDate: service?.vendorProfile?.vendorDetail?.liveDate,
    }),
    shallowEqual
  );

  const onboardingStatusFlag =
    store?.onboardingStatus !== "" &&
    checkOnBoardingStatus(store?.onboardingStatus, [LIVE]);

  useEffect(() => {
    setVisibleOptions();
  }, []);
  const [menusDisable, setMenusDisable] = useState("");
  const menusDisableForSellerHub = () => {
    const style = {
      color: "#999999",
      pointerEvents: "none",
    };
    return menusDisable ? style : {};
  };
  const highlightMenuItem = (navId) => {
    const param = history.location.pathname.split("/");
    const style = {
      padding: "8px",
      borderBottom: "4px solid red",
      borderRadius: "4px",
      fontWeight: "600",
    };

    if (
      param.includes(navId) ||
      (navId === "vendor" && param.includes("ops"))
    ) {
      return style;
    }

    return {};
  };

  const getMyDashboardAccess = () => {
    if (
      getUserRolePermission(
        RolePermissionConstants.VENDORPLATFORM_MYDASHBOARD_MYVENDORS,
        RolePermissionConstants.ALL
      ) !== RolePermissionConstants.NONE ||
      getUserRolePermission(
        RolePermissionConstants.VENDORPLATFORM_MYDASHBOARD_PREBOARDING,
        RolePermissionConstants.ALL
      ) !== RolePermissionConstants.NONE ||
      getUserRolePermission(
        RolePermissionConstants.VENDORPLATFORM_MYDASHBOARD_NEWVENDORS,
        RolePermissionConstants.ALL
      ) !== RolePermissionConstants.NONE ||
      getUserRolePermission(
        RolePermissionConstants.VENDORPLATFORM_MYDASHBOARD_ADDVENDOR,
        RolePermissionConstants.ALL
      ) !== RolePermissionConstants.NONE ||
      getUserRolePermission(
        RolePermissionConstants.VENDORPLATFORM_MYDASHBOARD_REPORTS,
        RolePermissionConstants.ALL
      ) !== RolePermissionConstants.NONE ||
      getUserRolePermission(
        RolePermissionConstants.VENDORPLATFORM_MYDASHBOARD_PIPELINE,
        RolePermissionConstants.ALL
      ) !== RolePermissionConstants.NONE ||
      getUserRolePermission(
        RolePermissionConstants.VENDORPLATFORM_MYDASHBOARD_MYTEAM,
        RolePermissionConstants.ALL
      ) !== RolePermissionConstants.NONE ||
      getUserRolePermission(
        RolePermissionConstants.VENDORPLATFORM_MYDASHBOARD_DBMAPPROVAL,
        RolePermissionConstants.ALL
      ) !== RolePermissionConstants.NONE ||
      getUserRolePermission(
        RolePermissionConstants.VENDORPLATFORM_MYDASHBOARD_MBEWBEAPPROVAL,
        RolePermissionConstants.ALL
      ) !== RolePermissionConstants.NONE
    ) {
      return true;
    } else {
      return false;
    }
  };

  const getDataByYear = (e) => {
    const value = e.target.value;
    setState((prevState) => ({
      ...prevState,
      selectedOption: value,
    }));
    history.push("/dashboard/" + value);
  };

  const isMtoUser = () => {
    if (context && context.roles) {
      return context.roles.roleName === ROLE_MTO_MEMBER;
    }
    return false;
  };

  /*
   * role : MtoAdmin, and ExternalVendor
   * OnBoardingStatus : live
   * only allowed to access shipping
   */
  const verifyShippingMenuAccess = () => {
    if (context?.roles?.roleName) {
      return onboardingStatusFlag;
    }
    return false;
  };

  const verifyDocumentLibraryAccess = () => {
    return Constants.ENABLE_DOC_LIBRARY === "D" ? false : true;
  };

  const verifyManageUserAccess = () => {
    //If externalGenericVendor then Live vendor should have access for parent child duns tab
    //ExternalGenericAdmin then Add User and Manage user access will be there and if Live vendor then Parent child duns tab access will also be there.
    //VDFOpsAdmin will have access of all three tabs.
    //Only primary vendor of particular corpName
    let isLiveVendor =
      (store?.onboardingStatus !== "" &&
        checkOnBoardingStatus(store?.onboardingStatus, [LIVE])) ||
      store?.liveDate;

    if (
      [Constants.EXTERNAL_VENDOR_GENERIC].includes(context?.roles?.roleName)
    ) {
      //externalGenericVendor
      if (isLiveVendor && store?.isPrimaryVendor) {
        return verifyAccessPermission("manageUsersParentChildDunsView");
      }
    } else {
      return verifyAccessPermission("manageUsersView");
    }
  };
  const getIsLiveVendor = () => {
    const userType =
      Cookie.get("userType") === "internal" &&
      context.roles.roleName === Constants.VDF_OPS_ADMIN;
    if (userType) {
      return true;
    }
    const isLiveVendor =
      store?.onboardingStatus !== "" &&
      checkOnBoardingStatus(store?.onboardingStatus, [LIVE]);
    return isLiveVendor;
  };
  const setVisibleOptions = () => {
    let search = false;
    let filter = false;
    let dashborad = false;

    if (context && context.roles) {
      if (!isMtoUser() && Cookie.get("userType") === "internal") {
        search = true;
      }
      if (!isMtoUser() && Cookie.get("userType") === "internal") {
        filter = true;
      }
      if (!isMtoUser() && Cookie.get("userType") === "internal") {
        dashborad = true;
      } else {
        let navlist = NavList.filter((nav) => nav.navId !== "dashboard");
        setState((prevState) => ({
          ...prevState,
          navList: navlist,
        }));
      }
      setState((prevState) => ({
        ...prevState,
        searchVisible: search,
        filterVisble: filter,
        dashboardVisible: dashborad,
      }));
    }
  };

  useEffect(() => {
    getDisableEnableConfig("sellerCentral", (response) => {
      setEnableFeature(response);
    });
    if (
      getUserRolePermission(
        RolePermissionConstants.VENDORPLATFORM_SELLER_CENTRAL_REPORTS_bkp,
        RolePermissionConstants.ALL
      ) === RolePermissionConstants.EDIT
    ) {
      httpGetVendorProfileByEmail(Cookie.get("email"))
        .then((res) => {
          if (
            res.data?.vendorDetail?.merchandiseType ===
              Constants.VOB_MERCHANDISE_TYPE_MARKETPLACE &&
            res.data?.vendorDetail?.liveDate
          ) {
            setMenusDisable(true);
            setIsVendorMPandLive(true);
          }
        })
        .catch((err) => console.log(err));
    }
  }, []);

  const [isVendorMPandLive, setIsVendorMPandLive] = useState(false);
  const [enableFeature, setEnableFeature] = useState("");
  useEffect(() => {
    if (enableFeature === Constants.ENABLED_FLAG) {
      if (
        getUserRolePermission(
          RolePermissionConstants.VENDORPLATFORM_SELLER_CENTRAL_MANAGE_REPORTS,
          RolePermissionConstants.ALL
        ) === RolePermissionConstants.EDIT
      ) {
        setMenusDisable(true);
      }
      if (
        getUserRolePermission(
          RolePermissionConstants.VENDORPLATFORM_SELLER_CENTRAL_REPORTS,
          RolePermissionConstants.ALL
        ) === RolePermissionConstants.EDIT
      ) {
        httpGetVendorProfileByEmail(Cookie.get("email"))
          .then((res) => {
            if (
              res.data?.vendorDetail?.merchandiseType ===
                Constants.VOB_MERCHANDISE_TYPE_MARKETPLACE &&
              res.data?.vendorDetail?.liveDate
            ) {
              setMenusDisable(true);
              setIsVendorMPandLive(true);
            } else if (
              res.data?.vendorDetail?.merchandiseType ===
                Constants.VOB_MERCHANDISE_TYPE_MARKETPLACE &&
              !res.data?.vendorDetail?.liveDate
            ) {
              if (location.pathname.indexOf("reports") > -1) {
                history.push(Constants.SELLER_REPORTS_PAGE_URL);
              }
            }
          })
          .catch((err) => console.log(err));
      }
    }
  }, [enableFeature]);

  const enableVendorOnboForSellerCentralAdmin = (navId) => {
    if (
      navId === Constants.VENDOR &&
      getUserRolePermission(
        RolePermissionConstants.VENDORPLATFORM_SELLER_CENTRAL_MANAGE_REPORTS,
        RolePermissionConstants.ALL
      ) === RolePermissionConstants.EDIT
    ) {
      return true;
    }
    return false;
  };

  return (
    <div>
      {context.roles && (
        <nav bg="white" className="item-menu">
          <Nav className="" style={{ width: "75%" }}>
            {!isMtoUser() &&
              state.navList.map((nav, i) => {
                if (nav.navId === "manageusers") {
                  if (verifyManageUserAccess() && getIsLiveVendor()) {
                    return (
                      <Link
                        id={nav.navId}
                        to={nav.navLink}
                        style={{
                          padding: 8,
                          ...highlightMenuItem(nav.navId),
                        }}
                        onClick={() => {
                          dispatch(updateServiceData({ fetching: true }));
                          dispatch(
                            updateLeftNav({
                              selectedSection: "",
                              activeAccordionKey: "",
                            })
                          );
                        }}
                        key={`${i}-${nav.navId}`}
                      >
                        {nav.navName}
                      </Link>
                    );
                  }
                } else if (nav.navId === "document-library") {
                  if (verifyDocumentLibraryAccess()) {
                    return (
                      <Link
                        id={nav.navId}
                        to={nav.navLink}
                        style={{
                          padding: 8,
                          ...menusDisableForSellerHub(),
                          ...highlightMenuItem(nav.navId),
                        }}
                        onClick={() => {
                          dispatch(updateServiceData({ fetching: true }));
                          dispatch(
                            updateLeftNav({
                              selectedSection: "",
                              activeAccordionKey: "",
                            })
                          );
                        }}
                        key={`${i}-${nav.navId}`}
                      >
                        {nav.navName}
                      </Link>
                    );
                  }
                } else if (nav.navId === "sellerreports") {
                  if (
                    (getUserRolePermission(
                      RolePermissionConstants.VENDORPLATFORM_SELLER_CENTRAL_MANAGE_REPORTS,
                      RolePermissionConstants.ALL
                    ) === RolePermissionConstants.EDIT ||
                      (getUserRolePermission(
                        RolePermissionConstants.VENDORPLATFORM_SELLER_CENTRAL_REPORTS,
                        RolePermissionConstants.ALL
                      ) === RolePermissionConstants.EDIT &&
                        isVendorMPandLive)) &&
                    enableFeature === Constants.ENABLED_FLAG
                  ) {
                    return (
                      <Dropdown className="seller-dropdown">
                        <Dropdown.Toggle
                          className="seller-reports-toggle"
                          variant="default"
                          id="dropdown-basic"
                          style={{
                            padding: 8,
                            ...highlightMenuItem(
                              nav.navId === "home" ? "mvp" : nav.navId
                            ),
                          }}
                        >
                          {nav.navName}
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          {state.sellerCentralNavSubList.map((subNav, i) => {
                            if (
                              subNav.navId === "managereports" &&
                              getUserRolePermission(
                                RolePermissionConstants.VENDORPLATFORM_SELLER_CENTRAL_MANAGE_REPORTS,
                                RolePermissionConstants.ALL
                              ) !== RolePermissionConstants.EDIT &&
                              getUserRolePermission(
                                RolePermissionConstants.VENDORPLATFORM_SELLER_CENTRAL_REPORTS,
                                RolePermissionConstants.ALL
                              ) === RolePermissionConstants.EDIT
                            ) {
                              return <></>;
                            }
                            return (
                              <Dropdown.Item
                                key={`${i}-${nav.navId}-${subNav.navId}`}
                              >
                                <Link
                                  style={{
                                    padding: 8,
                                    ...highlightMenuItem(
                                      subNav.navId === "home"
                                        ? "mvp"
                                        : subNav.navId
                                    ),
                                  }}
                                  id={subNav.navId}
                                  to={
                                    subNav.navLink === "/dashboard"
                                      ? "/dashboard/" + currentyear
                                      : subNav.navLink
                                  }
                                  onClick={() => {
                                    dispatch(
                                      updateServiceData({ fetching: true })
                                    );
                                    dispatch(
                                      updateLeftNav({
                                        selectedSection: "",
                                        activeAccordionKey: "",
                                      })
                                    );
                                  }}
                                  key={`${i}-${subNav.navId}`}
                                >
                                  {subNav.navName}
                                </Link>
                              </Dropdown.Item>
                            );
                          })}
                        </Dropdown.Menu>
                      </Dropdown>
                    );
                  }
                } else if (nav.navId === "shipping") {
                  if (verifyShippingMenuAccess() || isVendorMPandLive) {
                    return (
                      <Link
                        id={nav.navId}
                        to={nav.navLink}
                        style={{
                          padding: 8,
                          ...menusDisableForSellerHub(),
                          ...highlightMenuItem(nav.navId),
                        }}
                        onClick={() => {
                          dispatch(updateServiceData({ fetching: true }));
                          dispatch(
                            updateLeftNav({
                              selectedSection: VENDORPLATFORM_SUB_HEAD_LOCATIONDETAILS,
                              activeAccordionKey: "0",
                            })
                          );
                        }}
                        key={`${i}-${nav.navId}`}
                      >
                        {nav.navName}
                      </Link>
                    );
                  }
                } else if (nav.navId === "publishNotification") {
                  if (getUserRolePermission(
                    RolePermissionConstants.VENDORPLATFORM_MACYHOME_PUBLISH_NOTIFICATIONS,
                    RolePermissionConstants.ALL
                  ) === RolePermissionConstants.EDIT) {
                    return (
                      <Link
                        style={{
                          padding: 8,
                          ...highlightMenuItem(nav.navId),
                        }}
                        id={nav.navId}
                        to={nav.navLink}
                        key={`${i}-${nav.navId}`}
                      >
                        {nav.navName}
                      </Link>
                    )
                  }
                } else if (nav.navId !== "dashboard") {
                  return (
                    <Link
                      style={{
                        padding: 8,
                        ...(!enableVendorOnboForSellerCentralAdmin(nav.navId) &&
                          menusDisableForSellerHub()),
                        ...highlightMenuItem(
                          nav.navId === "home" ? "mvp" : nav.navId
                        ),
                      }}
                      id={nav.navId}
                      to={
                        nav.navLink === "/dashboard"
                          ? "/dashboard/" + currentyear
                          : nav.navLink
                      }
                      onClick={() => {
                        dispatch(updateServiceData({ fetching: true }));
                        dispatch(
                          updateLeftNav({
                            selectedSection: "",
                            activeAccordionKey: "",
                          })
                        );
                      }}
                      key={`${i}-${nav.navId}`}
                    >
                      {nav.navName}
                    </Link>
                  );
                } else if (getMyDashboardAccess()) {
                  return (
                    <Link
                      style={{
                        padding: 8,
                        ...menusDisableForSellerHub(),
                        ...highlightMenuItem(nav.navId),
                      }}
                      id={nav.navId}
                      to={
                        nav.navLink === "/dashboard"
                          ? "/dashboard/" + currentyear
                          : nav.navLink
                      }
                      key={`${i}-${nav.navId}`}
                    >
                      {nav.navName}
                    </Link>
                  );
                } 
              })}
            {isMtoUser() &&
              mtoUserNavList.map((nav, i) => {
                return (
                  <Link
                    style={{
                      padding: 8,
                      ...highlightMenuItem(nav.navId),
                    }}
                    id={nav.navId}
                    to={nav.navLink}
                    key={`${i}-${nav.navId}`}
                  >
                    {nav.navName}
                  </Link>
                );
              })}
          </Nav>
          <Nav style={{ width: "24%"}}>
          {state.searchVisible &&
              getUserRolePermission(
                RolePermissionConstants.VENDORPLATFORM_MACYHOME_GLOBALSEARCH,
                RolePermissionConstants.ALL
              ) === RolePermissionConstants.EDIT && <GlobalSearch />}
          </Nav>
        </nav>
      )}
    </div>
  );
};

export default MainNavigation;
